import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/about';
import Member from './pages/member';
import Contact from './pages/contact';
import Gallery from './pages/Gallery';
import Activity from './pages/activity';
import Media from './pages/Media';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/member-list" element={<Member />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/media" element={<Media />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
